import { render, staticRenderFns } from "./GrantDatasets.vue?vue&type=template&id=e5f929d4"
import script from "./GrantDatasets.vue?vue&type=script&lang=js"
export * from "./GrantDatasets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports